module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0031.jpg?v=d139f6eb";